import { Button } from "nq-component";
import BasePage from "../../../../../base/BasePage";
import CardView from "../../../../../components/common/CardView";
import TimeTableComponent from "../../../../../components/common/TimeTableComponent";
import { FloatingForm } from "../../../../../components/common/Converter";
import React from "react";
import PrintFunction from "../../../../../components/PrintFunction";
import {
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";

export default class PrintDTR extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      signatureApprove: "",
      signatureSupervisor: "",
      holidays: [],
      suspensions: [],
      leaves: [],
      manual_dtr: [],
      obLists: [],
    };

    this.printReference = React.createRef();
  }

  async componentDidMount() {
    document.body.classList.add("modal-open");
    this.setState({
      holidays: [],
      suspensions: [],
      leaves: [],
      manual_dtr: [],
      obLists: [],
    });
  }

  componentWillUnmount() {
    document.body.classList.remove("modal-open");
  }

  render() {
    const printContent = () => {
      const year = this.props.year;

      const { employee } = this.props;
      const month = this.props.availableMonth.indexOf(this.props.month);
      // console.log(month, year, employee);
      // if (!year || !month || !employee) {
      //   return;
      // }
      const monthString = this.props.availableMonth[month];

      // const dateToday = `${monthString} ${year}`;
      const lastDay = new Date(year, parseInt(month) + 1, 0).getDate() || "";

      const empName = [
        employee?.surname && `${employee.surname},`,
        employee?.Firstname,
        employee?.Middlename,
      ]
        .filter(Boolean)
        .map((name) => name.toUpperCase())
        .join(" ");
        
        const agencyEmpName = employee?.agency ? `[${employee?.agency}] ${empName}` : empName;

      return (
        <div ref={this.printReference}>
          <div style={{ paddingLeft: "1rem" }}>
            <p
              style={{
                textAlign: "",
                fontSize: "12px",
              }}
            >
              CIVIL SERVICE FORM NO. 48
            </p>
            <p
              style={{
                textAlign: "center",
                fontSize: "12px",
                margin: 0,
              }}
            >
              BUREAU OF IMMIGRATION
            </p>
            <p
              style={{
                margin: 0,
                textAlign: "center",
                fontSize: "12px",
              }}
            >
              Main Office
            </p>
            <p
              style={{
                textAlign: "center",
                fontSize: "12px",
                fontWeight: 500,
              }}
            >
              DAILY TIME RECORD
            </p>
            <span style={{ fontSize: "12px" }}>
              Name: <strong>{agencyEmpName}</strong>
            </span>
            <p style={{ fontSize: "12px", margin: 0 }}>
              01 - {lastDay} {monthString} {year}{" "}
            </p>
          </div>

          <TimeTableComponent
            dailyRec={this.props.dailyRec}
            month={month}
            year={year}
            employee={employee}
            watermark={this.props.watermark}
            lastDay={lastDay}
            holidays={this.state.holidays}
            suspensions={this.state.suspensions}
            leaves={this.state.leaves}
            manual_dtr={this.state.manual_dtr}
            obLists={this.state.obLists}
          />
          <p style={{ fontSize: "12px", paddingLeft: "1rem" }}>
            I certify on my honor that the above is a true and correct report of
            the hours of work performed, record of which was made daily at the
            time of arrival at and departure from office
          </p>

          <div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <input
                style={{
                  textAlign: "center",
                  width: "80%",
                  borderTop: 0,
                  borderLeft: 0,
                  borderRight: 0,
                }}
                onChange={(value) =>
                  this.setState({ signatureApprove: value.target.value })
                }
                value={empName}
              />
            </div>
            <p style={{ fontSize: "12px", textAlign: "center" }}>
              Employee Signature
            </p>
          </div>
          {/* <p style={{ fontSize: "12px", paddingLeft: "1rem" }}>Approved by:</p> */}
          <div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <input
                style={{
                  textAlign: "center",
                  width: "80%",
                  borderTop: 0,
                  borderLeft: 0,
                  borderRight: 0,
                }}
                onChange={(value) =>
                  this.setState({ signatureSupervisor: value.target.value })
                }
                value={this.state.signatureSupervisor}
              />
            </div>
            <p style={{ fontSize: "12px", textAlign: "center" }}>
              Authorized Signatory
            </p>
          </div>
        </div>
      );
    };

    const handlePrint = async () => {
      const original = this.printReference.current;
      const clone = original.cloneNode(true);

      // Remove remarks elements from the clone only
      // Adjust the selector to match your remarks element's class/attribute
      const remarksElements = clone.querySelectorAll(".remarks-cell");
      remarksElements.forEach((el) => el.remove());

      try {
        const currentUser = this.getCurrentUser();
        const formatted = new Date().toLocaleString("en-US", {
          month: "long", // July
          day: "numeric", // 25
          year: "numeric", // 2025
          hour: "numeric", // 12
          minute: "2-digit", // 03
          second: "2-digit", // 11
          hour12: true, // AM/PM
        });
        const data = {
          logDate: formatted,
          user: currentUser?.username || "",
          activity: "Print",
          message: "Print DTR",
        };
        await upsertUseCase().execute("audit_logs", data);
        PrintFunction(clone);
      } catch (e) {
        console.error(e);
      }
    };

    return (
      <>
        <FloatingForm width="55rem">
          <CardView
            style={{
              padding: 0,
              ...(this.props.watermark && {
                backgroundImage: "url(/dtrwatermark.png)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: 200,
                width: "100%",
              }),
            }}
          >
            <h4 className="fs-6 fw-bold pt-3 ps-3">Print DTR</h4>
            <hr />
            {/* <div className="row"> */}
            <div className="w-75 m-auto">{printContent()}</div>
            {/* <div className="col-lg-6 pe-5 ps-5">{printContent()}</div> */}
            {/* </div> */}
            <hr />
            <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
              <Button
                className="btn btn-light fs-sm"
                onClick={() => this.props.closeAccess()}
              >
                Cancel
              </Button>
              {!this.props.hide && (
                <Button
                  className="btn btn-primary"
                  onClick={() => handlePrint()}
                >
                  Print
                </Button>
              )}
            </div>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
